import React, { useState, useEffect } from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import TablaGeneral from "../../components/TablaGeneral";
import Loader from "../../components/Loader";
import configTable from "../../hook/configTable";

const ClientesPage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [datos, setDatos] = useState([])

  const [datosTabla] = useState({
    titulo: "Miembros/Socios",
    ruta: "/cliente",
    esAgregar: false,
    esEditar: false,
    esEliminar: false,
    esVerDetalle: true,
    rutaVerDetalle: "/cliente",
    configTable: configTable,
    keySucursal: "ID_SUC_CLI"
  })

  const [cabecera] = useState([
    { title: "ID", key: "ID_CLI" },
    { title: "NOMBRE", key: "NOMBRE" },
    { title: "CORREO", key: "CORREO_DP" },
    { title: "SESION", key: "SESION" },
    { title: "SUCURSAL", key: "NOMBRE_SUCURSAL_SUC" },
    { title: "RESPUESTA", key: "RESPUESTA_DP" },
    { title: "COMENTARIOS", key: "COMENTARIOS_DP" },
    { title: "ULTIMA SESIÓN", key: "ULTIMA_SESION_FECHA_CLI", isDate: true },
    { title: "FECHA ALTA", key: "FECHA_ALTA_CLI", isDate: true },
  ]);

  const cargarDatos = async () => {
    try {
      fetch("/p_clientes", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        }
      })
        .then((res) => res.json())
        .then((data) => {
          console.log(data);
          if (data.status === 1) {
            setDatos(data.data);
          }
          setIsLoading(false);
        });
    } catch (error) {
      console.error('Error:', error);
    }
  };

  useEffect(() => {
    cargarDatos();
  }, []);
  return (
    <>
      <MasterLayout>
        {isLoading ? <Loader /> : <TablaGeneral datosTabla={datosTabla} datos={datos} cabecera={cabecera} />}
      </MasterLayout>
    </>
  );
};

export default ClientesPage;
